import React from 'react';
import Translator from 'app/components/common/Translator';

export interface IPageContentHeaderProps {
    text: string,
}

export const PageContentHeader: React.FC<IPageContentHeaderProps> = ({
    text,
}) => {
    return (
        <h2 className="c-page__content--header">
            <Translator text={text} />
        </h2>
    );
};